import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import RegisterCard from "../components/RegisterCard";
import PopupOverlay from "../components/PopupOverlay";
import { LANGUAGES, useLanguage } from "../i18n";
import "./Header.css";

export default function Header({ onSessionChange }) {
  const [langOpen, setLangOpen] = useState(false);
  const [registerOpen, setRegisterOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [signedIn, setSignedIn] = useState(false);
  const [profileMenuOpen, setProfileMenuOpen] = useState(false);
  const { language, setLanguage, t } = useLanguage();

  useEffect(() => {
    let active = true;
    const refreshSession = () => fetch("/api/me", { credentials: "include" })
      .then((response) => response.ok ? response.json() : null)
      .then((data) => {
        if (!active) return;
        const user = data?.ok ? data.user : null;
        setSignedIn(Boolean(user));
        onSessionChange?.(user);
      })
      .catch(() => {
        if (!active) return;
        setSignedIn(false);
        onSessionChange?.(null);
      });
    refreshSession();
    window.addEventListener("bubly:session-changed", refreshSession);
    return () => {
      active = false;
      window.removeEventListener("bubly:session-changed", refreshSession);
    };
  }, [onSessionChange]);

  return (
    <>
      <div className={`bu-header ${mobileMenuOpen ? "mobile-menu-open" : ""}`}>

        {/* LOGO */}
        <div className="bu-logo">
          <img
            src="/assets/img/bublyuplogoheader.png"
            alt="BublyUp Logo"
            className="bu-logo-img"
          />
        </div>

        {/* MOBILE MENU BUTTON */}
        <button
          type="button"
          className="bu-menu-toggle"
          aria-label="Toggle navigation menu"
          aria-expanded={mobileMenuOpen}
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        {/* CENTERED NAVIGATION */}
        <nav className="bu-nav">
          <div
            className="profile-nav"
            onMouseEnter={() => setProfileMenuOpen(true)}
            onMouseLeave={() => setProfileMenuOpen(false)}
            onFocus={() => setProfileMenuOpen(true)}
            onBlur={(event) => {
              if (!event.currentTarget.contains(event.relatedTarget)) setProfileMenuOpen(false);
            }}
            onKeyDown={(event) => { if (event.key === "Escape") setProfileMenuOpen(false); }}
          >
            <Link
              className="profile-nav-trigger"
              to="/my-profile"
              onClick={() => { setProfileMenuOpen(false); setMobileMenuOpen(false); }}
            >
              {t("profileNav")}
            </Link>
            <div className="profile-nav-menu" role="menu" hidden={!profileMenuOpen}>
              <Link role="menuitem" to="/my-profile?tab=album" onClick={() => { setProfileMenuOpen(false); setMobileMenuOpen(false); }}>{t("myAlbum")}</Link>
              {signedIn && <Link role="menuitem" to="/account-settings" onClick={() => { setProfileMenuOpen(false); setMobileMenuOpen(false); }}>{t("accountSettings")}</Link>}
            </div>
          </div>
          <a href="#register">{t("navDate")}</a>
          <a href="#safety">{t("safety")}</a>
          <Link to="/support">{t("support")}</Link>
        </nav>

        {/* RIGHT-SIDE BUTTONS */}
        <div className="bu-right">

          {!signedIn && <>
            <button className="bu-btn bu-login" onClick={() => setRegisterOpen(true)}>{t("login")}</button>
            <button className="bu-btn bu-register" onClick={() => setRegisterOpen(true)}>{t("register")}</button>
          </>}

          <div className="language-picker">
            <button
              type="button"
              className="bu-btn bu-register language-btn"
              aria-haspopup="menu"
              aria-expanded={langOpen}
              onClick={() => setLangOpen((open) => !open)}
            >
              {t("language")}
            </button>

            <div
              className={`language-menu ${langOpen ? "is-open" : ""}`}
              role="menu"
              hidden={!langOpen}
            >
              {LANGUAGES.map((item) => (
                <button
                  key={item.code}
                  type="button"
                  role="menuitemradio"
                  aria-checked={language === item.code}
                  className={language === item.code ? "is-selected" : ""}
                  onClick={() => { setLanguage(item.code); setLangOpen(false); }}
                >
                  {item.label}
                </button>
              ))}
            </div>
          </div>

        </div>
      </div>

      {registerOpen && (
        <PopupOverlay onClose={() => setRegisterOpen(false)}>
          <RegisterCard onClose={() => setRegisterOpen(false)} />
        </PopupOverlay>
      )}
    </>
  );
}
